import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';

import BudgetList from './BudgetList';
import BudgetCreate from './BudgetCreate';
import BudgetShow from './BudgetShow';
import BudgetEdit from './BudgetEdit';

const budgets = {
	list: BudgetList,
	create: BudgetCreate,
	show: BudgetShow,
	edit: BudgetEdit,
	icon: EuroSymbolIcon
};

export default budgets;
